export enum AutomationEventType {
  Campaign = 0,
  auto_clt_sub_signup_completed = 1,
  auto_clt_sub_signup_failed = 2,
  auto_clit_birthday = 3,
  auto_clt_sub_signup_link_generated = 7,
  auto_clt_invoice_created = 8, /// This needs to be renamed to InvoiceCreated
  auto_clt_non_recurring_payment_received = 9, /// This needs to be renamed to PaymentsCreated
  auto_clt_waiver_completed = 10, // This needs to be renamed to WaiverCompleted
  Feedback = 11, //TODO : DELETE ME as Discussed
  ClientRenewalReminder = 12, ///TODO : DELETE ME - > This can already be achieved by Membership expired  [MembershipExpired - 31]
  auto_clt_flagged_clt_at_risk = 13,
  ClientSubscriptionActivation = 14, //TODO : DELETE ME as Discussed
  auto_clt_password_reset_triggered = 15,
  RequestAccess = 16, //Need to develop the functionality
  ClientProspectCreation = 17, //TODO : DELETE ME as Discussed
  auto_clt_transferor_consent_request_initiated = 19,
  auto_clt_sales_return_created = 20,
  auto_clt_refund_processed = 21,
  Other = 22,
  auto_clt_tour_booked = 23,
  auto_clt_recurring_appt_booked = 24,
  auto_clt_single_appt_rescheduled = 25,
  auto_clt_sub_cancellation_date = 26,
  auto_clt_class_waitlist_spot_vacated = 27,
  auto_clt_trial_start_date = 28,
  auto_clt_sub_start_date = 29,
  auto_clt_sub_end_date = 30,
  auto_clt_membership_end_date = 31,
  auto_clt_membership_start_date = 32,
  auto_clt_newlead_created = 33,
  auto_clt_tour_marked_noshow = 34,
  auto_clt_sub_cancellation_requested = 35,
  auto_clt_single_appt_booked = 36,
  auto_clt_recurring_appt_rescheduled = 37,
  auto_clt_trial_end_date = 38,
  auto_clt_trial_created = 39,
  auto_clt_abandoned_sub_signup = 40,
  auto_clt_low_risk_clt_arrived = 41,
  auto_clt_moderate_risk_clt_arrived = 42,
  auto_clt_high_risk_clt_arrived = 43,
  auto_clt_pending_cancellation_clt_arrived = 44,
  auto_clt_appointee_arrived = 45,
  auto_clt_single_appt_date = 46,
  auto_clt_single_appt_cancelled = 47,
  auto_clt_single_appt_marked_noshow = 48,
  auto_clt_recurring_appt_cancelled = 49,
  auto_class_rescheduled = 50,
  auto_class_coach_substituted = 51,
  auto_class_cancelled = 52,
  auto_clt_class_booked = 53,
  auto_clt_class_session_date = 54,
  auto_clt_class_booking_cancelled = 55,
  auto_clt_recurring_payment_received = 56,
  auto_clt_recurring_payment_failed = 57,
  auto_clt_invoice_voided = 58,
  auto_clt_payment_voided = 59,
  auto_clt_sales_return_voided = 60,
  auto_clt_sub_freeze_created = 61,
  auto_clt_sub_freeze_start_date = 62,
  auto_clt_sub_freeze_end_date = 63,
  auto_clt_sub_freeze_voided = 64,
  auto_clt_sub_freeze_stopped = 65,
  auto_clt_sub_voided = 66,
  auto_clt_tour_scheduled_date = 67,
  auto_clt_repeat_enq_created = 68,
  auto_clt_class_marked_attended = 70,
  auto_clt_class_marked_noshow = 71,
  manage_clt_sub_link = 72,
  invoice_clear_balance_link = 73,
  auto_generate_and_send_member_password = 74,
  auto_clt_initiate_otp_for_saved_card = 75,
  auto_clt_non_recurring_payment_failed = 76,
  auto_sdr = 77,
  auto_clt_otp_for_login = 78,
  auto_clt_waiver_pending_reminder = 79,
}

export enum AutomationView {
  CalendarView = 1,
  MinuteView = 2,
}

export enum AutomationScheduleType {
  Day = 1,
  Hour = 2,
  Minute = 3,
}

export enum ActionType {
  Email = 1,
  SMS = 2,
  WhatsApp = 3,
  Task = 4,
  Opportunity = 4,
}

export enum WorkflowEventType {
  NewleadCreated = 100,
  SubcriptionActivated = 200,
  SubcriptionExpired = 201,
}

export enum AutomationTimings {
  Before = 1,
  Immediate = 2,
  After = 3,
  SameDay = 4,
  NonAutomation = 5,
  BackendImmedidate = 6,
  BackendNonImmedidate = 7,
}

export enum SendNotificationTo {
  Client,
  Staff,
  Both,
}

export enum OwnershipLevel {
  Company = 1,
  Franchise = 2,
  Tenant = 3,
}

export enum OwnershipLevelOrder {
  Tenant = 1,
  Franchise = 2,
  Company = 3
}

export enum AutomationCategory
{
    Sales = 1,
    Retention = 2,
    Backend_Event = 3,
    Billing_Payment = 4,
    Memberships_Subscriptions = 5,
    Appointments = 6,
    Classes = 7,
    Freeze = 8,
}
